import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralSettingsComponent } from './general-settings/general-settings.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { UserModule } from '../user/user.module';
import { EmailModule } from '../email/email.module';
import { FormModule } from '../form-builder/form.module';
import { PrimaryAccountComponent } from './primary-account/primary-account.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { BranchesComponent } from './branches/branches.component';
import { SharedModule } from '../shared/shared.module';
import { DateTimeSettingsComponent } from './date-time-settings/date-time-settings.component';
import { OptionValueAddComponent } from './option-value-add/option-value-add.component';
import { RoleAndPermissionComponent } from './role-and-permission/role-and-permission.component';
import { InitialsPipe } from '../pipes/initials.pipe';
import { ConfigurationSettingsComponent } from './configuration-settings/configuration-settings.component';
import { AppIntegrationsComponent } from './app-integrations/app-integrations.component';
import { SelectButtonModule } from "primeng/selectbutton";
import { Popover } from "primeng/popover";
import { Select } from "primeng/select";



@NgModule({
  declarations: [
    GeneralSettingsComponent,
    PrimaryAccountComponent,
    CompanyDetailsComponent,
    BranchesComponent,
    DateTimeSettingsComponent,
    OptionValueAddComponent,
    RoleAndPermissionComponent,
    ConfigurationSettingsComponent,
    AppIntegrationsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    SharedModule,
    UserModule,
    EmailModule,
    FormModule,
    InitialsPipe,
    SelectButtonModule,
    Popover,
    Select
],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SettingsModule { }
